module.exports = __webpack_public_path__ + "img/sponser-8.68614119.png";